import SelectionEditor from './selectionEditor';

export default SelectionEditor;
